import React, { useEffect, useState } from "react";
import Xray from "../../../../images/xray.png";
// import { getAllDocumentsByID } from "../../../../Utils/localStore";

const DocumentView = ({ onClose, details }) => {
  const image = details.documentUrl ?? Xray;

  return (
    <>
      {/* <section onClick={(e) => { e.preventDefault(); onClose() }} className=" bg-black bg-opacity-25 w-[100%] h-[100%] font-euclid-circular-a fixed top-0 right-0 flex-col justify-start items-start">
    </section>
       */}

      <dialog>
        <div className="font-euclid-circular-a w-full h-screen justify-center items-center overflow-hidden m-auto flex">
          <div className="font-euclid-circular-a bg-white w-[760px]shadow justify-start items-start p-4 overflow-auto">
            <div className="cursor-pointer relative z-50 rounded-full bg-white flex items-center p-2">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  onClose();
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="24"
                  viewBox="0 0 18 24"
                  fill="none"
                >
                  <path
                    d="M2.25 23.5L0.5 21.225L7.5 12.125L0.5 3.025L2.25 0.75L9.25 9.85L16.25 0.75L18 3.025L11 12.125L18 21.225L16.25 23.5L9.25 14.4L2.25 23.5Z"
                    fill="black"
                  />
                </svg>
              </button>
            </div>

            <div className=" font-euclid-circular-a bg-white w-[740px] h-[585px] shadow flex-col justify-start items-start p-4 overflow-auto">
              <img src={image} alt="bone xray" />
            </div>
          </div>
        </div>
      </dialog>
    </>
  );
};

export default DocumentView;
